<h2 style="margin-top: 30px; margin-left: 10px">Lähetä tilinpäätös allekirjoitettavaksi</h2>

@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px; padding-left: 20px">
    <h4 style="margin: 0">Urit</h4>
    <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
      Lähetykset: <a [href]="tilinpaatosLahetyksetEncodedUriObservable | async" target="_BLANK">{{ tilinpaatosLahetyksetUriObservable | async }}</a>
    </div>
    <div style="padding-top: 0em; padding-left: 1em; padding-right: 1em">
      Status: <a [href]="tilinpaatosStatusEncodedUriObservable | async" target="_BLANK">{{ tilinpaatosStatusUriObservable | async }}</a>
    </div>
  </div>
}

@if (lukittuObservable | async) {
  <div style="padding: 3em; font-weight: bold">Tilinpäätös on rekisteröity. Tietoja ei voi enää muokata.</div>
}

@if (!(tilintarkastetaanObservable | async)) {
  @if (customTilinpaatosLadattuObservable | async) {
    <div style="padding: 20px">Allekirjoitettu tilinpäätös on ladattu manuaalisesti Lemonaidiin. Lähetystä ei voi tehdä. Jos tämä on mielestäsi virhe, ota yhteys tekniseen tukeen.</div>
  } @else {
    <div style="padding: 20px">Lähetä -nappula siirtää tilinpäätöksen asiakkaan Lemonaidiin allekirjoitettavaksi.</div>
    @if (!(taseErittelyObservable | async)) {
      <p class="left-padded-text">Tase-erittelyä ei ole luotu. Ole hyvä ja luo tase-erittely ennen lähettämistä.</p>
    }
    @if (taseErittelyLuotuTilikaudestaPoikkeavalleAjalleObservable | async) {
      <p class="left-padded-text">Tase-erittely on tehty tilikaudesta poikkeavalle ajalle. Tee erittely koko tilikaudelle.</p>
    }
    @if (liitetiedotLuomattaObservable | async) {
      <p class="left-padded-text">Liitetietoja ei ole luotu. Ole hyvä ja luo liitetiedot ennen lähettämistä.</p>
    }
    @if (merkittyAllekirjoitettavaksiMuuallaObservable | async) {
      <p class="left-padded-text">Liitetietojen mukaan tilinpäätös allekirjoitetaan perinteisesti. Lähetystä ei voi jatkaa.</p>
    }
    @if (errorTextSubject | async; as errorText) {
      <div class="error-text left-padded-text">{{ errorText }}</div>
    }
    @if (hallitusEiKunnossaObservable | async) {
      <div class="error-text left-padded-text">Yrityksen hallituksen tiedot puuttuvat. Tarkista tuntemistiedot.</div>
    }
    <div style="padding: 30px 0">
      <div style="text-align: center; padding: 0 20px">
        <app-primary-button (click)="lahetaAllekirjoitettavaksi()" [disabled]="sendDisabledObservable | async" actionId="Lähetä tilinpäätös allekirjoitettavaksi"> Lähetä allekirjoitettavaksi </app-primary-button>
      </div>
    </div>
    @if (tilinpaatosUsersObservable | async; as userData) {
      <div style="padding: 0 20px 20px 20px">
        <h4 style="margin: 0">Allekirjoittajat:</h4>
        <div style="margin: 0 10px 15px">
          <table style="width: 100%">
            <tr style="vertical-align: bottom">
              <th style="text-align: left"></th>
              <th style="text-align: left"></th>
              <th>Edellytykset<br />allekirjoittaa</th>
              <th>Tilinpäätös</th>
              <th>Varsinainen<br />yhtiökokous</th>
            </tr>
            <tr>
              <th style="text-align: left">Hallitus</th>
              <th colspan="4"></th>
            </tr>
            @for (hallitusUser of userData.hallitus; track hallitusUser) {
              <tr>
                <td>
                  {{ hallitusUser.name }}
                  @if (hallitusUser.link) {
                    <a matTooltip="Avaa käyttäjän tiedot uudessa ikkunassa" style="margin-left: 5px; font-size: 120%" target="_blank" [href]="hallitusUser.link"><span class="fa fa-external-link"></span></a>
                  }
                </td>
                <td>{{ hallitusUser.role || 'Ei roolia' }}</td>
                <td style="text-align: center; font-size: 120%">
                  @if (hallitusUser.lemonaidUidConnected) {
                    <span class="green-text">
                      <i class="fa fa-check"></i>
                    </span>
                  }
                  @if (!hallitusUser.lemonaidUidConnected) {
                    <span style="cursor: pointer" class="red-text" [matTooltip]="eiLemonaidKayttajaaText"> X <i class="icon ion-ios-information-circle-outline"></i> </span>
                  }
                </td>
                <td style="text-align: center">
                  <i class="fa fa-circle"></i>
                </td>
                <td></td>
              </tr>
            }
            <tr>
              <td colspan="5">&nbsp;</td>
            </tr>
            <tr>
              <th style="text-align: left">Osakkaat</th>
              <th colspan="4"></th>
            </tr>
            @for (osakasUser of userData.osakkaat; track osakasUser) {
              <tr>
                <td>
                  {{ osakasUser.name }}
                  @if (osakasUser.link) {
                    <a matTooltip="Avaa käyttäjän tiedot uudessa ikkunassa" style="margin-left: 5px; font-size: 120%" target="_blank" [href]="osakasUser.link"><span class="fa fa-external-link"></span></a>
                  }
                </td>
                <td></td>
                <td style="text-align: center; font-size: 120%">
                  @if (osakasUser.lemonaidUidConnected) {
                    <span class="green-text">
                      <i class="fa fa-check"></i>
                    </span>
                  }
                  @if (!osakasUser.lemonaidUidConnected) {
                    <span style="cursor: pointer" class="red-text" [matTooltip]="eiLemonaidKayttajaaText"> X <i class="icon ion-ios-information-circle-outline"></i> </span>
                  }
                </td>
                <td></td>
                <td style="text-align: center">
                  <i class="fa fa-circle"></i>
                </td>
              </tr>
            }
          </table>
        </div>
      </div>
    } @else {
      <div class="left-padded-text">Asiakas tuntemistietoja ei ole tallennettu</div>
    }
    @if (kirjanpitajaOnDevaajaTaiTukiObservable | async) {
      <div style="padding: 20px">
        <app-primary-button (click)="resetPoytakirja()" [disabled]="sendDisabledObservable | async" actionId="Tyhjennettiin varsinaisen yhtiökokouksen pöytäkirja"> Tyhjennä varsinaisen yhtiökokouksen pöytäkirja </app-primary-button>
        <div>Aikasemmat resetit:</div>
        @if (resetHistoryObservable | async; as resetHistory) {
          @if (resetHistory.length) {
            @for (history of resetHistory; track history) {
              <div>{{ history.kirjanpitaja }} {{ history.aika }}</div>
            }
          } @else {
            Pöytäkirjaa ei ole resetoitu kertaakaan.
          }
        } @else {
          <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
        }
      </div>
    }
  }
  <div style="padding: 30px 0">
    <div class="laheta-tab-title" style="text-align: center; margin-top: 30px">Aikaisemmin allekirjoitettavaksi lähetetyt tilinpäätökset</div>
    @if (sentThisTilikausiObservable | async; as aikaisemmatTilinpaatokset) {
      <table style="margin: 10px auto">
        <tr>
          <th>Lähetetty</th>
          <th>Lähettäjä</th>
          <!-- <th>Lataa siirtotiedosto</th>
          <th>Lataa PDF</th> -->
        </tr>
        @for (paatos of aikaisemmatTilinpaatokset; track paatos) {
          <tr>
            <td style="padding: 0 10px 0 0">{{ paatos.luotuDateStr }}</td>
            <td style="padding: 0 10px">{{ paatos.nimi }}</td>
            <!-- <td style="padding: 0 10px;">
            <button mat-button class="secondarybutton" (click)="lataaTyviTiedosto(ilmo)">Lataa siirtotiedosto</button>
          </td>
          <td style="padding: 0 0 0 10px;">
            <button mat-button class="secondarybutton" (click)="downloadPdf(ilmo)">Lataa PDF</button>
          </td> -->
          </tr>
        }
      </table>
    } @else {
      <div style="text-align: center; padding: 25px">Yhtään tilinpäätöstä ei ole vielä lähetetty.</div>
    }
  </div>
} @else {
  <div style="padding: 20px">
    Tilintarkastettava tilinpäätös on allekirjoitettava perinteisesti ja ladattava takaisin Lemonatoriin "Rekisteröinti" -välilehdellä.
    <br /><br />
    Voit lähettää tilinpäätöksen asiakkaalle alla olevan sähköpostin liitteenä.
  </div>
}

<div app-tilinpaatos-email-lahetys [tilintarkastetaanObservable]="tilintarkastetaanObservable" [voiLahettaaObservable]="tilinpaatossahkoopostinVoiLahettaaObservable" [selectedTilikausiObservable]="selectedTilikausiObservable" [paivitaArvotHiljaisestiObservable]="paivitaArvotHiljaisestiObservable" [lukittuObservable]="lukittuObservable"></div>
